import { effect, teardown } from '../../../reactivity/effects.js';
import { listen_to_event_and_reset_event } from './shared.js';
import { is } from '../../../proxy.js';
import { is_array } from '../../../../shared/utils.js';
import * as w from '../../../warnings.js';
import { Batch, current_batch, previous_batch } from '../../../reactivity/batch.js';

/**
 *
 *
 *
 *
 *
 */
export function select_option(select, value, mounting = false) {
	if (select.multiple) {
		/*                                                      */
		if (value == undefined) {
			return;
		}

		/*                                                 */
		if (!is_array(value)) {
			return w.select_multiple_invalid_value();
		}

		/*                              */
		for (var option of select.options) {
			option.selected = value.includes(get_option_value(option));
		}

		return;
	}

	for (option of select.options) {
		var option_value = get_option_value(option);
		if (is(option_value, value)) {
			option.selected = true;
			return;
		}
	}

	if (!mounting || value !== undefined) {
		select.selectedIndex = -1; /*                           */
	}
}

/**
 *
 *
 *
 *
 *
 *
 */
export function init_select(select) {
	var observer = new MutationObserver(() => {
		/*         */
		select_option(select, select.__value);
		/*                                                     */
		/*                                                      */
	});

	observer.observe(select, {
		/*                               */
		childList: true,
		subtree: true, /*                    */
		/*                                               */
		/*                                             */
		/*                                                      */
		attributes: true,
		attributeFilter: ['value']
	});

	teardown(() => {
		observer.disconnect();
	});
}

/**
 *
 *
 *
 *
 */
export function bind_select_value(select, get, set = get) {
	var batches = new WeakSet();
	var mounting = true;

	listen_to_event_and_reset_event(select, 'change', (is_reset) => {
		var query = is_reset ? '[selected]' : ':checked';
		/*                  */
		var value;

		if (select.multiple) {
			value = [].map.call(select.querySelectorAll(query), get_option_value);
		} else {
			/*                                   */
			var selected_option =
				select.querySelector(query) ??
				/*                                                                   */
				select.querySelector('option:not([disabled])');
			value = selected_option && get_option_value(selected_option);
		}

		set(value);

		if (current_batch !== null) {
			batches.add(current_batch);
		}
	});

	/*                                                                                                                        */
	effect(() => {
		var value = get();

		if (select === document.activeElement) {
			/*                                                                                       */
			var batch = /*                */ (previous_batch ?? current_batch);

			/*                                                                           */
			/*                                                                   */
			//
			/*                                         */
			/*                            */
			if (batches.has(batch)) {
				return;
			}
		}

		select_option(select, value, mounting);

		/*                                                      */
		if (mounting && value === undefined) {
			/*                                   */
			var selected_option = select.querySelector(':checked');
			if (selected_option !== null) {
				value = get_option_value(selected_option);
				set(value);
			}
		}

		/*         */
		select.__value = value;
		mounting = false;
	});

	init_select(select);
}

/*                                    */
function get_option_value(option) {
	/*                                                        */
	if ('__value' in option) {
		return option.__value;
	} else {
		return option.value;
	}
}
